import React, { useState, useEffect } from 'react';
import { Button, Grid, Paper, Typography } from '@mui/material';
import PublicHeader from 'components/PublicHeader';
import IntlMessages from 'lngProvider/IntlMessages';
import FooterWrapper from 'components/Footer';
import SignInService from 'services/SignInService';
import { SignInResultType } from 'services/EnumConstants';
import { styled } from '@mui/material/styles';
import { getPaperStyleObject } from 'styles/Paper';
import useQueryParams from 'hooks/useQueryParams';

const StyledPaper = styled(Paper)((
    {
        theme
    }
    ) => {
        let paperStyle = getPaperStyleObject(theme);
        return {
            ...paperStyle.root
        };
    });

const ExternalLoginError = () => {
    const [loginConfig, setLoginConfig] = useState(null);
    const [returnUrl, setReturnUrl] = useState(null);
    const [resultTypeCode, setResultTypeCode] = useState(0);
    const { getQueryParamByName } = useQueryParams();

    useEffect(() => {
        const fetchData = () => {
            let url = getQueryParamByName('ReturnUrl');
            let result = parseInt(getQueryParamByName('result'));
            setReturnUrl(url);
            setResultTypeCode(result);

            SignInService.getLogInConfig(url).then(data => setLoginConfig(data));
        };

        fetchData();

    }, [getQueryParamByName]);

    document.title = "3M - External Login Error";

    const getErrorId = () => {
        var signInError = 'logIn.externalLoginError';

        switch (resultTypeCode) {
        case SignInResultType.AccountInactivated:
            signInError = 'logIn.accountInactivated';
            break;
        case SignInResultType.NoRoles:
            signInError = 'logIn.notAForesightUser';
            break;
        default:
            console.warn(`Invalid SignInResultType of ${resultTypeCode}`);
        }

        return signInError;
    };

    const handleClick = () => {
        window.location.href = returnUrl;
    }

    return (
        <section>
            {loginConfig && loginConfig.showPublicHeader === true ?
                <PublicHeader />
                : ''}
            <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={12}>
                    <Grid container alignItems="center" justifyContent="center" direction="column">
                        <Grid item xs={12}>
                            <StyledPaper>
                                <Grid container alignItems="center" justifyContent="center" direction="column" spacing={4}>
                                    <Grid item xs={12}>

                                        <Typography variant="h4" className="mt-4"><IntlMessages id="logIn.externalLoginError" /></Typography>
                                        <Typography variant="subtitle2" className="mt-2"><IntlMessages id={getErrorId()} /></Typography>

                                    </Grid>

                                    <Grid item xs={12}>
                                        <Button
                                            color="primary"
                                            variant="contained"
                                            onClick={handleClick}>
                                            <IntlMessages id="logIn.tryAgain" />
                                        </Button>
                                    </Grid>
                                </Grid>
                            </StyledPaper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <FooterWrapper />
        </section>
    );
};

export default ExternalLoginError;